import { computed } from 'vue';
import { useStore } from 'vuex';

const useAuth = () => {
   const store = useStore();

   const createUser = async (user) => {
      const resp = await store.dispatch('auth/createUser', user);
      return resp;
   };

   const loginUser = async (user) => {
      try {
         const response = await store.dispatch('auth/signInUser', {
            email: user.email,
            password: user.password,
         });
         return response;
      } catch (error) {
         throw error;
      }
   };

   const checkAuthentication = async () => {
      const resp = await store.dispatch('auth/checkAuthentication');
      return resp;
   };

   const logout = () => {
      // Reset all modules state and remove token from local storage
      store.commit('bsa/resetState', null, { root: true });
      store.commit('cliente/resetState', null, { root: true });
      store.commit('poliza/resetState', null, { root: true });
      store.commit('main/resetState', null, { root: true });
      store.commit('agro/resetState', null, { root: true });
      store.commit('auth/resetState', null, { root: true });
      store.commit('siniestros/resetState', null, { root: true });
      store.commit('art/resetState', null, { root: true });
      store.commit('automotor/resetState', null, { root: true });

      store.commit('auth/removeToken', store.state);
   };

   return {
      createUser,
      loginUser,
      checkAuthentication,
      logout,

      authStatus: computed(() => store.getters['auth/currentState']),
      username: computed(() => store.getters['auth/username']),
   };
};

export default useAuth;
